export default "__VITE_ASSET__2a69ba85__"